export function removeLocaleFromUrl (url) {
  return url.replace(/\/en(\/|$|#|\?)/g, '$1');
}
